import React from 'react';

import Spinner from 'components/shared/Spinner';

class ParenthoodFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const button = e.currentTarget;
    const oldStatus = button.getAttribute('data-status');
    const newStatus = oldStatus == 'active' ? 'default' : 'active';
    const relationship = button.getAttribute('data-relationship');

    let active = this.props.value || [];

    let index = active.indexOf(relationship);
    if (newStatus == 'active' && index == -1) {
      active.push(relationship);
      active.sort();
    }
    if (newStatus != 'active' && index != -1 ) {
      active.splice(index, 1);
    }

    if (this.props.onChange) {
      this.props.onChange(active);
    }
  }

  render() {
    let relationships = [
      {
        label: 'Istituto comprensivo',
        value: 'parent',
        status:this.props.value && this.props.value.indexOf('parent') !== -1 ? 'active' : 'default'
      },
      {
        label: 'Plesso',
        value: 'child',
        status: this.props.value && this.props.value.indexOf('child') !== -1 ? 'active' : 'default'
      }
    ];

    let tabs = relationships.map((tab) => {
      var extraClass = '';
      switch (tab.status) {
        case 'active':
          extraClass = 'btn-primary active';
          break;
        case 'disabled':
        case 'busy':
          extraClass = 'btn-secondary disabled';
          break;
        case 'default':
        default:
          extraClass = 'btn-secondary default';
      }

      return (
        <button
          data-relationship={tab.value}
          data-status={tab.status}

          className={'btn' + (extraClass ? ' ' + extraClass : '') + ' py-2 mb-1 mr-1'}
          style={{
            position: 'relative',
            width: 'auto',
            minWidth: '0',
            fontSize: '95%',
            cursor: tab.status == 'default' ? 'pointer' : 'default'
          }}

          onClick={tab.status != 'disabled' && tab.status != 'busy' ? this.handleClick : () => false}
        >
          <i className={(tab.status == 'active' ? 'fa fa-circle' : 'far fa-circle') + ' mr-1'} /> {tab.label}
          {tab.status == 'busy' ? <span style={{position: 'absolute', left: 'calc(50% - 0.6em)'}}><Spinner message="" /></span> : ''}
        </button>
      );
    });

    return (
      <div className="mr-1">
        {tabs}
      </div>
    );
  }
}

export default ParenthoodFilter;


// WEBPACK FOOTER //
// ./src/components/shared/filters/ParenthoodFilter.js